module.exports = __webpack_public_path__ + "media/pro/MediaKit-e6f36723.svg";